import React from 'react';
import { IErrorProps } from '../types/IFormError';

function ErrorForm(params: IErrorProps) {
    return (
        <div className="row errorForm">
            <div className="col-12">
                <div className="section error-section" style={{ display: 'block' }}>
                    <div className="fieldset-title">
                        <h5>
                            <strong>{params.validationSectionTitle}</strong>
                        </h5>
                    </div>
                    <div className="field error-fields-list-container">
                        <ul className="error-fields-list">
                            {params.errors.map((error) => (
                                <li key={error.controlName}>
                                    <a
                                        aria-label={`${error.controlName}-error`}
                                        href={`#${error.controlName}`}
                                        dangerouslySetInnerHTML={{ __html: error.message }}
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ErrorForm;
